module.exports = __webpack_public_path__ + "img/feedback6.6301ade2.png";